'use client';

import { ChevronLeft, ChevronRight } from 'lucide-react';
import React from 'react';

interface DrawerGroupNavigationProps {
  onPrev?: () => void;
  onNext?: () => void;
  currentIndex?: number;
  totalCount?: number;
}

/** The arrows through a grouped pin's results ("2 / 3"), shown when it holds more than one. */
export function DrawerGroupNavigation({ onPrev, onNext, currentIndex, totalCount }: DrawerGroupNavigationProps) {
  if (totalCount === undefined || totalCount <= 1) return null;
  return (
    <div className="flex items-center justify-between px-2 py-2 border-b border-neutral-200">
      <button
        onClick={onPrev}
        className="flex items-center justify-center w-8 h-8 rounded-full hover:bg-neutral-100 text-neutral-600"
        aria-label="Previous activity"
      >
        <ChevronLeft size={20} />
      </button>
      <span className="text-sm font-medium text-neutral-600">
        {(currentIndex ?? 0) + 1} / {totalCount}
      </span>
      <button
        onClick={onNext}
        className="flex items-center justify-center w-8 h-8 rounded-full hover:bg-neutral-100 text-neutral-600"
        aria-label="Next activity"
      >
        <ChevronRight size={20} />
      </button>
    </div>
  );
}
